if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handlePossibleFalseFailure(formData, response);
            return;
          }

          this.error = false;
          this.showCartNotification(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handlePossibleFalseFailure(formData, response) {
      const addedVariantId = parseInt(formData.get('id'), 10);

      fetch(`${routes.cart_url}.js`, { cache: 'no-store' })
        .then((r) => r.json())
        .then((cart) => {
          const addedItem = cart.items.find((item) => item.id === addedVariantId);

          if (addedItem) {
            this.error = false;
            this.fetchAndShowCartNotification(addedItem.key, response.description);
            return;
          }

          this.showFailure(response);
        })
        .catch(() => {
          this.showFailure(response);
        });
    }

    showFailure(response) {
      this.handleErrorMessage(response.description);

      const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      if (!soldOutMessage) return;
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.querySelector('span').classList.add('hidden');
      soldOutMessage.classList.remove('hidden');
      this.error = true;
    }

    fetchAndShowCartNotification(itemKey, warningMessage) {
      const sectionIds = this.cartNotification.getSectionsToRender().map((section) => section.id);
      fetch(`${routes.cart_url}?sections=${sectionIds.join(',')}`, { cache: 'no-store' })
        .then((r) => r.json())
        .then((sections) => {
          this.showCartNotification({ key: itemKey, sections }, warningMessage);
        })
        .catch((e) => {
          console.error(e);
        });
    }

    // cart:updated MUST fire only once #cart-icon-bubble has actually been
    // rewritten with fresh data from THIS response — for the quick-add-modal
    // path, renderContents is deferred until the modal finishes closing, so
    // the dispatch has to be deferred right along with it (in the same
    // callback), never fired early from a blanket finally. Firing it early
    // meant MinimumOrderGate re-checked stale, pre-add data for that one
    // flow (quick-add from a collection page), which looked identical to
    // the message never clearing.
    showCartNotification(parsedState, warningMessage = null) {
      const notifyUpdated = () => document.dispatchEvent(new CustomEvent('cart:updated'));
      const quickAddModal = this.closest('quick-add-modal');
      try {
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => {
              try {
                this.cartNotification.renderContents(parsedState, warningMessage);
              } finally {
                notifyUpdated();
              }
            });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cartNotification.renderContents(parsedState, warningMessage);
          notifyUpdated();
        }
      } catch (e) {
        console.error(e);
        if (!quickAddModal) notifyUpdated();
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
